function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesPortal = function SvgSalesPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.01 2.652H3.99c-.737 0-1.335.598-1.335 1.335v16.02c0 .737.598 1.335 1.335 1.335h16.02c.737 0 1.335-.598 1.335-1.335V3.987c0-.737-.598-1.335-1.335-1.335M2.655 7.992h18.69M8 3v18M21.35 14.662H8"
  }));
};
export default SvgSalesPortal;